import { Component, inject} from '@angular/core';
import { ToastNotificationService } from '../core/toast-notification.service';
import { UIBlockingService } from '../core/ui-blocking.service';
import { MemberAdService } from './member-ad.service';
import { AdUploadResult } from './DTOs/file-upload-result';
import { MemberAdRequest } from './DTOs/member-ad-request';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AdType } from './DTOs/AdTypes';

@Component({
  selector: 'app-submit-member-ad',
  templateUrl: './submit-member-ad.component.html',
  providers: [UIBlockingService]

})
export class SubmitMemberAdComponent {
    constructor(private memberAdService: MemberAdService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService,
        private route: ActivatedRoute,
        private router: Router) { }

    adImage: File = null;
    preview = "";
    submitPressed = false;
    memberNotes = "";
    adUrl = "";
    adSize = "";
    adType = new AdType();
    imageTypes = ['image/jpeg', 'image/png', 'image/webp'];
    maxAdFileSize = 75000; // 75 KB
    disabledSubmitButton = false;
    ngOnInit() {
        this.route.params.subscribe(params => {
            var adtype = +params['adtype'];
            this.getAdTypeDetails(adtype);
        });
    }

    getAdTypeDetails(adType: number) {
        this.blockUI.start();
        this.memberAdService.getAdTypeDetails(adType).subscribe({
            next: (data) => {
                console.log(data);
                this.adType = data;
            },
            error: (err) => {
                this.notificationService.error(err.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
            }
        });
    }

    updateAdImage(files: FileList) {
        if(!this.imageTypes.includes(files.item(0).type)){
            this.notificationService.error("File is not a recognized image type.")
            this.disabledSubmitButton = true;
            return;
        }
        if (files.item(0).size > this.maxAdFileSize) {
            this.notificationService.error("File is larger than the maximum file size.");
            this.disabledSubmitButton = true;
            return;
        }
        this.disabledSubmitButton = false;
        this.adImage = files.item(0);
        const reader = new FileReader();

        reader.onload = (e: any) => {
            this.preview = e.target.result;
        }
        reader.readAsDataURL(files.item(0));
    }

    submitAd() {
        if (this.adImage == null) return;
        var url = URL.createObjectURL(this.adImage);
        var img = new Image;

        var checkAdForSize = (width: number, height: number) => {
            this.submitPressed = true;

            var dimensions = this.adSize.split('x').map(x => parseInt(x));
            if (width != dimensions[0] || height != dimensions[1]) {
                this.notificationService.error(`Ad dimensions do not match chosen type.\nSubmitted Ad dimensions: ${width}x${height}`);
                return;
            }
                    
            this.blockUI.start();
            this.uploadFile()
                .subscribe({
                    next: (data: AdUploadResult) => {
                        this.submitMemberAd(data.fileStorageId);
                    },
                    error: (err) => {
                        console.log(err);
                        this.notificationService.error(err.message);
                        this.blockUI.stop();
                    }
                });
        }
        img.onload = function () {
            //this.begin(img.width, img.height);
            checkAdForSize(img.width, img.height);
            URL.revokeObjectURL(img.src);
        };

        img.src = url;
    }



    submitMemberAd(adImageId: string) {
        let req = new MemberAdRequest(adImageId, this.memberNotes, this.adType.type, this.adUrl);
        this.memberAdService.submitMemberAd(req)
            .subscribe({
                next: (data) => {
                    console.log('Observable emitted the next value: ' + data);
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    console.log('Observable emitted the complete notification');
                    this.notificationService.success("Successfully submitted ad");
                    this.blockUI.stop();
                    this.router.navigate(['/admin-portal/member/member-ads/']);
                }
            });
    }

    uploadFile() {
        const uploadData = new FormData();
        uploadData.append('mainImage', this.adImage, this.adImage.name);
        return this.memberAdService.uploadAdFile(uploadData);
    }

    getSizeDisplay(size: string) {
        var dimensions = size.split('x');
        return `${dimensions[0]}px by ${dimensions[1]}px`;
    }

}
